import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Badge } from '@material-ui/core';
import { selectListTotal } from '../../../lists/selectors';
import { useResourceList } from '../../../lists/hooks';
import { useBadgeRefresh } from './useBadgeRefresh';
import { EMAIL_RESOURCE } from '../../../api/resources';
import { useUser } from '../../../auth/hooks';

const MailBadge = ({ children }) => {
    const user = useUser();
    const listId = 'emails.defaultFilter';

    const criteria = useMemo(
        () => ({
            check: (item) => {
                return (
                    item.checked_at === null &&
                    item.customer_id !== null &&
                    item.employee_id === user.employeeId &&
                    item.read_at === null
                );
            },
        }),
        [user]
    );

    const { handlePage: handleMailReminder } = useResourceList({
        listId,
        resource: EMAIL_RESOURCE,
        criteria,
        staticParams: {
            customerEmployee: [user.employeeId],
            readAt: 'null',
        },
        autoload: false,
        refresh: true,
        continuous: true,
    });

    const count = useSelector((state) => selectListTotal(state, listId));

    useBadgeRefresh(handleMailReminder, EMAIL_RESOURCE);

    return (
        <Badge badgeContent={count} color="primary" key={`mailbadge.${listId}`}>
            {children}
        </Badge>
    );
};

MailBadge.propTypes = {
    children: PropTypes.node.isRequired,
};

MailBadge.defaultProps = {};

export default MailBadge;
